import { Chip } from '@heroui/react';
import type { FC } from 'react';
import { type AccountFlagEnum, getAccountFlagLabel } from '@/app/types/account-flag.type.ts';

interface AccountFlagBadgeProps {
  accountFlagId?: AccountFlagEnum;
}

const AccountFlagBadge: FC<AccountFlagBadgeProps> = ({ accountFlagId }) => {
  const label = getAccountFlagLabel(accountFlagId);

  if (!label) {
    return null;
  }

  return (
    <Chip size='sm' variant='flat' color='warning'>
      {label}
    </Chip>
  );
};

export default AccountFlagBadge;
